// extracted by mini-css-extract-plugin
module.exports = {"greetingBox":"Dashboard_greetingBox__i-KoL"};